<div [ngStyle]="{ left: windowWidth }"
     *ngIf="showSplash"
     class="splash splash-bg">

  <div class="splash-logo"></div>

</div>
